import React from 'react';
import { C, LAYOUT } from '../../shared/design-tokens.js';
import { categoryPresentation, formatCategoryLabel } from './activity-ui.js';
import type { ActivityEvent } from './use-activity-read-model.js';

function formatDetail(detail: string | Record<string, unknown> | null | undefined): string {
  if (!detail) return '—';
  if (typeof detail === 'string') return detail;
  try {
    return Object.entries(detail)
      .map(([k, v]) => `${k}: ${v}`)
      .join(' · ');
  } catch (e) {
    return '—';
  }
}

function formatTime(ts: string | null | undefined): string {
  if (!ts) return '—';
  const d = new Date(ts);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true });
}

export default function ActivityFeed({ activity }: { activity: ActivityEvent[] }) {
  if (!activity || activity.length === 0) {
    return (
      <div style={{ ...LAYOUT.subPanel, textAlign: 'center', padding: 40, color: C.textMuted }}>
        No recent activity found.
      </div>
    );
  }

  return (
    <div style={{ display: 'grid', gap: 10 }}>
      {activity.map((event) => {
        const { color, background, border } = categoryPresentation(event.category || '');
        return (
          <div
            key={event.id}
            style={{
              padding: '12px 16px',
              borderRadius: 10,
              background: C.panel,
              border: `1px solid ${C.borderSoft}`,
              display: 'grid',
              gridTemplateColumns: '70px 4px 1fr 120px',
              alignItems: 'center',
              gap: 12,
            }}
          >
            <div style={{ fontFamily: 'DM Mono, monospace', fontSize: 11, color: C.textMuted }}>
              {formatTime(event.created_at)}
            </div>
            <div style={{ height: 24, width: 4, borderRadius: 2, background: color }} />
            <div style={{ overflow: 'hidden' }}>
              <div style={{ color: C.text, fontSize: 13, fontWeight: 600, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {event.manager_name || event.email || '—'}
              </div>
              <div style={{ color: C.textMuted, fontSize: 11, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {formatDetail(event.detail)}
              </div>
            </div>
            <div style={{ textAlign: 'right' }}>
              <span
                style={{
                  display: 'inline-block',
                  padding: '3px 8px',
                  borderRadius: 4,
                  fontSize: 10,
                  fontFamily: 'DM Mono, monospace',
                  textTransform: 'uppercase',
                  letterSpacing: '0.05em',
                  color,
                  background,
                  border: `1px solid ${border}`,
                }}
              >
                {event.action || '—'}
              </span>
              <div style={{ color: C.textMuted, fontSize: 9, marginTop: 4, textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                {formatCategoryLabel(event.category)}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
